/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { withLocalize, Translate } from 'react-localize-redux';
import { Button, Container, Row, Col, Card, CardBody } from 'reactstrap';
import defaultTestimonials from '../services/data/testimonials';
import getLanguage from '../services/helpers';
import getPath from '../assets/routes/paths';

function MainFooter() {
  const language = getLanguage();

  const [testimonials, setTestimonials] = useState(null);

  useEffect(() => {
    if (defaultTestimonials[language]) {
      setTestimonials(shuffle(defaultTestimonials[language]).slice(0, 3));
    }
  }, [language]);

  const shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  return (
    <footer className="footer footer-big">
      <Container>
        <Row>
          <Col>
            <Row>
              <Col xs="6" md="3">
                <h6 className="bold mt-4 mb-2">
                  <Translate id="footer.get-started" />
                </h6>
                <div className="links">
                  <ul>
                    <li>
                      <Link to={getPath(language, 'HowItWorks')}>
                        <Translate id="navbar.how-it-works" />
                      </Link>
                    </li>
                    <li>
                      <Link to={getPath(language, 'Plus')}>PLUS</Link>
                    </li>
                    {['sv'].includes(language) && (
                      <li>
                        <Link to={getPath(language, 'Trophy')}>
                          <Translate id="navbar.trophy" />
                        </Link>
                      </li>
                    )}
                    {['sv', 'dk'].includes(language) && (
                      <>
                        {/* <li>
                          <Link to={getPath(language, 'IndoorOpen')}>Indoor Open</Link>
                        </li> */}
                        <li>
                          <Link to={getPath(language, 'Deals')}>Deals</Link>
                        </li>
                      </>
                    )}
                    {/* {['sv'].includes(language) && (
                      <li>
                        <a href="https://www.drivingforceawards.com" target="__blank">
                          Driving Force Awards
                        </a>
                      </li>
                    )} */}
                    <li>
                      <a href="https://merch.golfamore.com" target="__blank">
                        Merch
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col xs="6" md="3">
                {/* <div className="links" style={{ paddingTop: '50px' }}> */}
                <div className="links">
                  <h6 className="bold mt-4 mb-2">
                    <Translate id="footer.good-to-know" />
                  </h6>
                  <ul>
                    <li>
                      <Link to={getPath(language, 'Faq')}>
                        <Translate id="default.faq" />
                      </Link>
                    </li>
                    <li>
                      <Link to={getPath(language, 'GolfClub')}>
                        <Translate id="navbar.club" />?
                      </Link>
                    </li>
                    {['sv', 'dk', 'no', 'fi'].includes(language) && (
                      <li>
                        <Link to={getPath(language, 'Retailers')}>
                          <Translate id="navbar.retailers" />
                        </Link>
                      </li>
                    )}
                    {['sv', 'dk', 'no', 'en', 'de'].includes(language) && (
                      <li>
                        <Link to={getPath(language, 'CustomerClub')}>
                          <Translate id="navbar.club19" />
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </Col>
              <Col md="3" xs="6">
                <h6 className="bold mt-4 mb-2">
                  <Translate id="default.contact" />
                </h6>
                <div className="links">
                  <ul>
                    <li>
                      <Link to={getPath(language, 'About')}>
                        <Translate id="default.about" />
                      </Link>
                    </li>
                    <li>
                      <Link to={getPath(language, 'Contact')}>
                        <Translate id="default.contact-us" />
                      </Link>
                    </li>
                    {['sv', 'dk', 'no', 'de', 'en'].includes(language) && (
                      <li>
                        <Link to={getPath(language, 'News')}>
                          <Translate id="navbar.news" />
                        </Link>
                      </li>
                    )}
                    {language === 'sv' && (
                      <li>
                        <Link to={getPath(language, 'Press')}>
                          <Translate id="default.press" />
                        </Link>
                      </li>
                    )}

                    {/* <li>
                        <Link to={getPath(language, 'Privacy')}>
                          <Translate id="default.privacy-policy" />
                        </Link>
                      </li>
                      <li>
                        <Link to={getPath(language, 'Terms')}>
                          <Translate id="default.terms" />
                        </Link>
                      </li>
                      <li>
                        <Link to={getPath(language, 'Cookies')}>
                          <Translate id="default.cookies" />
                        </Link>
                      </li> */}
                  </ul>
                </div>
              </Col>
              <Col md="3" xs="6">
                <h6 className="bold mt-4 mb-2">
                  <Translate id="footer.legal" />
                </h6>
                <div className="links">
                  <ul>
                    {language !== 'de' && (
                      <>
                        <li>
                          <Link to={getPath(language, 'Privacy')}>
                            <Translate id="default.privacy-policy" />
                          </Link>
                        </li>
                        <li>
                          <Link to={getPath(language, 'Terms')}>
                            <Translate id="default.terms" />
                          </Link>
                        </li>
                        <li>
                          <Link to={getPath(language, 'Cookies')}>
                            <Translate id="default.cookies" />
                          </Link>
                        </li>
                      </>
                    )}
                    {language === 'de' && (
                      <>
                        <li>
                          <Link to="/de/agb">AGB & Kundeninfo</Link>
                        </li>
                        <li>
                          <Link to="/de/widerrufsbelehrung">Widerrufsbelehrung</Link>
                        </li>
                        <li>
                          <Link to="/de/datenschutzerklarung">Datenschutz</Link>
                        </li>
                        <li>
                          <Link to="/de/impressum">Impressum</Link>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col sm="5">
            <h6 className="bold mb-2">
              <Translate id="footer.secure-payments" />
            </h6>

            <div className="badge">
              <svg className="logo" role="presentation" viewBox="0 0 1000 323.7">
                <path
                  fill="#00579f"
                  d="M433.2 318.9h-80.7L403 5.7h81.1zM727 13.3C711 7 685.7 0 654.4 0c-80 0-136.4 42.7-136.7 103.7-.7 45 40.3 70 71 85 31.3 15.3 42 25.3 42 39-.3 21-25.3 30.6-48.7 30.6-32.3 0-49.6-5-76-16.6l-10.7-5L484 307c19 8.6 54 16.3 90.4 16.7 85 0 140.3-42 141-107 .3-35.7-21.4-63-68-85.4-28.4-14.3-45.7-24-45.7-38.6.3-13.4 14.6-27 46.6-27 26.4-.7 45.7 5.6 60.4 12L716 81l11-67.7zM834.7 208l32.3-87.7c-.3.7 6.7-18.3 10.7-30l5.7 27L902 208h-67.3zm100-202.3H872c-19.3 0-34 5.6-42.3 26L709.4 319h85l17-47h104l9.6 47h75L934.7 5.7zM284.7 5.7l-79.4 213.6-8.6-43.3C182 126 136 71.7 84.7 44.7l72.6 274H243l127.3-313h-85.6z"
                />
                <path fill="#faa61a" d="M131.7 5.7H1.3L0 12c101.7 26 169 88.7 196.7 164L168.3 32c-4.6-20-19-25.7-36.6-26.3z" />
              </svg>
            </div>
            <div className="badge">
              <svg className="logo" role="presentation" viewBox="0 0 200 155.6">
                <path
                  fill="#231f20"
                  d="M196 153.4v.4h.5v-.2-.2h-.2zm.3-.3l.5.1c.2.1.1.2.1.4l-.1.3-.4.2.5.5h-.4l-.4-.5h-.2v.5h-.3v-1.5zm0 2h.4a1.3 1.3 0 00.7-.7 1.3 1.3 0 00-.3-1.4l-.4-.3h-.5a1.2 1.2 0 00-.9.3l-.3.4v1l.3.4.4.2.5.1m0-2.9a1.6 1.6 0 011.2.5 1.6 1.6 0 01.3 1.8 1.7 1.7 0 01-.8.9l-.7.1a1.7 1.7 0 01-1.7-1.6c0-.2 0-.5.2-.7a1.6 1.6 0 01.9-.8l.6-.2m-153-5.8c0-2.9 1.8-5.2 4.9-5.2 3 0 5 2.2 5 5.2s-2 5.3-5 5.3c-3.1 0-5-2.4-5-5.3m13.3 0v-8.2h-3.6v2a6.2 6.2 0 00-5.2-2.4c-4.6 0-8.2 3.6-8.2 8.6s3.6 8.6 8.2 8.6c2.4 0 4-.9 5.2-2.4v2h3.6zm120.6 0c0-2.9 1.9-5.2 5-5.2 2.9 0 4.9 2.2 4.9 5.2s-2 5.3-5 5.3-5-2.4-5-5.3m13.4 0v-14.8h-3.6v8.6a6.2 6.2 0 00-5.2-2.4c-4.6 0-8.2 3.6-8.2 8.6s3.6 8.6 8.2 8.6c2.3 0 4-.9 5.2-2.4v2h3.6zm-89.6-5.4c2.3 0 3.8 1.4 4.1 4h-8.5c.4-2.4 1.8-4 4.4-4m0-3.2c-4.8 0-8.1 3.5-8.1 8.6 0 5.2 3.5 8.6 8.4 8.6a10 10 0 006.7-2.3l-1.7-2.6a7.8 7.8 0 01-4.8 1.7c-2.3 0-4.4-1-5-4h12.3v-1.4c0-5.1-3.1-8.6-7.7-8.6m43 8.6c0-2.9 2-5.2 5-5.2s5 2.2 5 5.2-2 5.3-5 5.3-5-2.4-5-5.3m13.3 0v-8.2h-3.5v2a6.2 6.2 0 00-5.2-2.4c-4.6 0-8.2 3.6-8.2 8.6s3.6 8.6 8.2 8.6c2.3 0 4-.9 5.2-2.4v2h3.5zm-33.4 0c0 5 3.5 8.6 8.7 8.6 2.5 0 4.2-.5 6-2l-1.8-2.8a7.2 7.2 0 01-4.3 1.5c-2.8 0-5-2.1-5-5.3s2.2-5.2 5-5.2c1.6 0 3 .5 4.3 1.4l1.7-2.8a8.6 8.6 0 00-5.9-2c-5.2 0-8.7 3.6-8.7 8.6m46-8.6c-2 0-3.4 1-4.3 2.4v-2h-3.6v16.4h3.6v-9.2c0-2.7 1.2-4.2 3.5-4.2.7 0 1.5.1 2.2.4l1.1-3.4c-.8-.3-1.8-.4-2.5-.4M74 139.5c-1.7-1.1-4-1.7-6.7-1.7-4.1 0-6.8 2-6.8 5.3 0 2.6 2 4.3 5.7 4.8l1.7.2c2 .3 2.8.8 2.8 1.8 0 1.2-1.3 2-3.7 2-2.5 0-4.3-.8-5.5-1.8L60 153c2 1.4 4.4 2.1 7 2.1 4.8 0 7.6-2.2 7.6-5.3 0-3-2.2-4.4-5.8-5l-1.7-.2c-1.5-.2-2.7-.5-2.7-1.6 0-1.2 1.1-2 3-2 2.2 0 4.2.9 5.2 1.5zm46-1.7c-2 0-3.3 1-4.2 2.4v-2h-3.6v16.4h3.6v-9.2c0-2.7 1.2-4.2 3.5-4.2.7 0 1.5.1 2.2.4l1.1-3.4c-.8-.3-1.8-.4-2.5-.4m-30.5.4h-5.8v-5h-3.6v5h-3.3v3.3h3.3v7.5c0 3.8 1.5 6 5.7 6 1.5 0 3.3-.4 4.4-1.2l-1-3c-1 .5-2.2.8-3.1.8-1.8 0-2.4-1-2.4-2.7v-7.4h5.8zm-53.3 16.4v-10.3c0-3.9-2.5-6.5-6.5-6.5-2 0-4.2.6-5.7 3a6 6 0 00-5.5-3c-1.7 0-3.4.5-4.8 2.4v-2h-3.5v16.4h3.6v-9c0-3 1.5-4.4 4-4.4 2.3 0 3.5 1.5 3.5 4.3v9.1H25v-9c0-3 1.7-4.4 4-4.4 2.5 0 3.7 1.5 3.7 4.3v9.1z"
                />
                <path
                  fill="#f79410"
                  d="M198.1 100v-2.3h-.6l-.7 1.6-.7-1.6h-.7v2.3h.5v-1.8l.7 1.6h.4l.7-1.6v1.8zm-4 0v-2h.9v-.3h-2v.4h.7v2z"
                />
                <path fill="#ff5f00" d="M127 110.4H73V13.2h54z" />
                <path fill="#eb001b" d="M76.5 61.8c0-19.8 9.2-37.3 23.6-48.6a61.8 61.8 0 100 97.2 61.7 61.7 0 01-23.6-48.6" />
                <path fill="#f79e1b" d="M200 61.8a61.8 61.8 0 01-100 48.6 61.7 61.7 0 000-97.2 61.8 61.8 0 01100 48.6" />
              </svg>
            </div>
            <div className="badge">
              <svg
                className="logo"
                role="presentation"
                style={{ transform: 'scale(1.1)' }}
                fill="none"
                height="323"
                viewBox="0 0 1000 323"
                width="1000"
              >
                <path d="m0 0h1000v323h-1000z" fill="#fff" />
                <g fill="#006fcf">
                  <path d="m932.677 223.714h29.2c24.334 0 38.123 13.062 38.123 35.919s-15.411 38.367-42.178 38.367h-63.268v-26.939h63.268c6.489 0 10.544-4.081 10.544-9.796 0-5.714-4.055-9.796-10.544-9.796h-29.201c-23.522 0-38.122-13.061-38.122-35.918 0-21.224 15.411-37.551 42.178-37.551h64.89l-12.167 26.939h-52.723c-5.678 0-10.545 3.265-10.545 8.979 0 5.715 4.056 9.796 10.545 9.796z" />
                  <path d="m816.687 223.714h29.2c24.334 0 38.123 13.062 38.123 35.919s-15.412 38.367-42.179 38.367h-63.267v-26.939h63.267c6.489 0 10.545-4.081 10.545-9.796 0-5.714-4.056-9.796-10.545-9.796h-29.2c-23.523 0-38.123-13.061-38.123-35.918 0-21.224 15.412-37.551 42.179-37.551h64.889l-12.167 26.939h-52.722c-5.678 0-10.545 3.265-10.545 8.979 0 5.715 4.056 9.796 10.545 9.796z" />
                  <path d="m760.719 297.184h-99.768v-119.184h99.768v26.939h-68.134v18.775h66.512v26.939h-66.512v19.592h68.134z" />
                  <path d="m362.458 178h40.556l-51.911 57.959 53.534 61.225h-41.368l-32.444-37.551-31.634 37.551h-40.556l52.723-60.408-51.912-58.776h41.367l30.823 35.918z" />
                  <path d="m253.768 297.184h-99.768v-119.184h99.768v26.939h-68.134v18.775h66.512v26.939h-66.512v19.592h68.134z" />
                  <path
                    clipRule="evenodd"
                    d="m477.638 178h-68.946v119.184h31.634v-39.184h36.501c26.767 0 42.989-17.143 42.989-40 0-23.673-16.223-40-42.178-40zm-37.312 53.061h34.067c8.922 0 13.789-5.714 14.6-13.061 0-7.347-4.866-13.061-14.6-13.061h-34.067z"
                    fillRule="evenodd"
                  />
                  <path
                    clipRule="evenodd"
                    d="m644.729 216.367c0-22.857-16.223-38.367-42.179-38.367h-68.134v119.184h31.634v-41.633h11.356l35.689 41.633h38.934l-38.934-43.266c19.467-4.081 31.634-18.775 31.634-37.551zm-79.49 12.245h33.256c8.922 0 13.789-4.898 14.6-11.428 0-6.531-4.867-12.245-14.6-12.245h-33.256z"
                    fillRule="evenodd"
                  />
                  <path d="m948.153 96.9315-48.707-71.9315h-39.777v118h31.659v-75.1644l49.519 75.1644h38.153v-118h-30.847zm-184.273-4.0411 16.235-39.6027 16.236 39.6027zm-3.247-67.8904-51.954 118h34.906l9.742-24.247h55.2l10.553 24.247h35.719l-53.578-118zm-103.907 59.8082v-2.4246c0-17.7809 9.741-29.9041 30.035-29.9041h35.718v-27.4795h-38.153c-38.965 0-59.26 25.0548-59.26 57.3836v2.4246c0 36.3698 22.73 57.3838 57.636 57.3838h10.553l12.989-26.671h-18.671c-18.671.808-30.847-9.699-30.847-30.7128zm-79.554-59.8082v118h31.659v-118zm-63.319 50.1096h-33.283v-23.4384h33.283c9.742 0 14.612 5.6576 14.612 12.1233 0 6.4658-4.87 11.3151-14.612 11.3151zm46.271-12.1233c0-22.6301-16.235-37.9863-42.212-37.9863h-68.189v118h31.659v-41.219h11.365l35.718 41.219h39.777l-38.965-42.836c19.483-4.0407 30.847-18.5887 30.847-37.1777zm-231.355 80.0137h99.848v-26.671h-68.189v-19.3975h66.565v-26.6712h-66.565v-18.5891h68.189v-26.6712h-99.848zm-100.66-43.6438-26.789-74.3562h-49.518v118h30.847v-84.863l30.848 84.863h28.412l31.659-84.863v84.863h30.847v-118h-49.518zm-172.0966-6.4658 16.2355-39.6027 16.2355 39.6027zm-4.0588-67.8904-51.9536 118h34.9063l9.7413-24.247h55.2007l10.5527 24.247h35.718l-52.7649-118z" />
                </g>
              </svg>
            </div>

            {language === 'de' && (
              <img
                src="/react-assets/img/paypal-logo.png"
                alt="PayPal Logo"
                style={{ width: '80px', marginTop: '10px', display: 'block' }}
              />
            )}
          </Col>
          <Col sm="3">
            <h6 className="bold mt-4 mb-2">
              <Translate id="footer.social-media" />
            </h6>
            <div className="d-flex social mt-2 align-items-center">
              <Button className="btn-just-icon btn-round mr-2" color="facebook" aria-label="Facebook">
                <a href="https://www.facebook.com/golfamore" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <i className="fa fa-facebook" />
                </a>
              </Button>
              <Button className="btn-just-icon btn-round mr-2" color="instagram" aria-label="Instagram">
                <a href="https://www.instagram.com/golfamore/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <i className="fa fa-instagram" />
                </a>
              </Button>
            </div>
          </Col>
        </Row>
        {['sv', 'de', 'dk'].includes(language) && (
          <>
            <h6 className="bold mt-5 mb-3">
              <Translate id="default.testimonials" />
            </h6>
            <Row className="mt-3">
              {testimonials?.map((t) => (
                <Col sm="4" key={t.id}>
                  <Card>
                    <CardBody>
                      <p className="text-italic" style={{ fontSize: '14px' }}>
                        {t.text}
                      </p>
                      <span className="bold">{t.name}</span>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <Row>
              <Col>
                <hr />
                <div className="copyright">
                  <div className="pull-right">© Golfhäftet i Sverige AB, all rights reserved</div>
                  <small style={{ color: '#a49e9e' }}>{process.env.REACT_APP_VERSION}</small>
                </div>
              </Col>
            </Row>
          </>
        )}
        <Row>
          <Col>
            {language === 'sv' && (
              <Row className="footer-logotypes mt-4">
                <Col xs="12" sm="4">
                  <img src="/react-assets/img/swgt-official-partner.png" className="img-fluid" alt="Swedish Golf team official partner" />
                </Col>
                <Col xs="12" sm="4" className="d-flex justify-content-center align-items-center pt-4">
                  <img
                    src="/react-assets/img/dgu-partner.png"
                    className="img-fluid"
                    style={{ maxWidth: '100%' }}
                    alt="Danish Golf Union partner"
                  />
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default withLocalize(MainFooter);
